import { useQuery } from "@apollo/client"
import { endOfDay, IANATimeZone, toTimestamp } from "@hydrologiq/common/helpers/date"
import { startOfDay } from "@hydrologiq/common/helpers/date"
import { GetInstallationLatestDocument } from "@hydrologiq/gql/graphql"
import { DataSource } from "@hydrologiq/schemas/1.0.0/installationPage"
import Comparison from "@hydrologiq/shared/monitoring/figures/Comparison"
import { DateTime } from "timezonecomplete"
interface GenericComparisonProps {
  source: DataSource
  sourceComparison: DataSource
  title: string
  unit: string
  description: string
  period: string
  installationId: string
  installationEndDate: DateTime
  installationStartDate: DateTime
}

function GenericComparison(props: GenericComparisonProps) {
  const {
    source,
    sourceComparison,
    title,
    unit,
    description,
    period,
    installationId,
    installationStartDate,
    installationEndDate,
  } = props

  const start = toTimestamp(startOfDay(installationStartDate), true)
  const stop = toTimestamp(endOfDay(installationEndDate), true)
  const location = IANATimeZone()

  const { loading, error, data } = useQuery(GetInstallationLatestDocument, {
    variables: {
      id: installationId,
      field: source.field,
      bucket: source.influx?.bucket,
      start,
      stop,
      location,
    },
  })

  const {
    loading: loadingComparison,
    error: errorComparison,
    data: dataComparison,
  } = useQuery(GetInstallationLatestDocument, {
    variables: {
      id: installationId,
      field: sourceComparison.field,
      bucket: sourceComparison.influx?.bucket,
      start,
      stop,
      location,
    },
  })

  return (
    <Comparison
      title={title}
      period={period}
      quantity={data?.latest?.value ?? 0}
      previousQuantity={dataComparison?.latest?.value ?? 0}
      description={description}
      unit={unit}
      error={error?.message || errorComparison?.message}
      loading={loading || loadingComparison}
    />
  )
}

export default GenericComparison
